<template>
  <div style="display: inline-block;">
    <span @click="show()" :id="'package'+order.id">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false"
      :modal="!mobiletype" :visible.sync="dialogFormVisible" width="90%" @close="close()">
      <div :class="{mobile_upload_order:mobiletype}">
        <h3 class="text-center"><i v-if="step > 1" class="el-icon-arrow-left back" @click="step--"></i>商品退货</h3>
        <ul class="error-messages" v-if="!isEmptyErrors">
          <li v-for="error in errors">{{error[0].message}}</li>
        </ul>
        <div style="height:100%;" v-if="step == 1">
          <!-- <el-row class="select-address">
          <el-col :span="24" class="tip">
            选择取消商品
          </el-col>
        </el-row> -->
              <ProductList ref="ProductList" @showChooseImage="showChooseImage" :groupOrderLine="groupOrderLine"
                :order="order" :goods_info="goods_info" :numEditable="true" :operation="'退货'" @checkNext="canNext()"
                v-on:changeType="changeType" :need_input_price="order.type==2"></ProductList>
          <el-form>
            <el-row>
              <el-col :span="24">
                <el-form-item>
                  <el-button style="margin: 20px 0 20px;" :disabled="notNext" class="block" :type="'primary'" :loading="isStartCaculating" @click="next">下一步</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div v-if="step == 3">
          <ul v-if="predata" class="popover-price">
            <li><span>商品</span><del
                v-if="predata.goods_price.need_frontend_calculate!=1 && predata.original_goods_price.value != predata.goods_price.value">{{predata.original_goods_price.currency_symbol}}{{predata.original_goods_price.value}}</del>
              <label v-if="predata.goods_price.need_frontend_input!=1">{{predata.goods_price.currency_symbol}}{{predata.goods_price.value}}</label>
              <el-input v-if="predata.goods_price.need_frontend_input==1" placeholder="价格" v-model="predata.goods_price.value">
                <template slot="append">{{predata.goods_price.currency}}</template>
              </el-input>
            </li>
            <li><span>消费税</span><del
                v-if="predata.tax_price.need_frontend_calculate!=1 && predata.original_tax_price.value != predata.tax_price.value">{{predata.original_tax_price.currency_symbol}}{{predata.original_tax_price.value}}</del>
                <label v-if="predata.tax_price.need_frontend_input!=1">{{predata.tax_price.currency_symbol}}{{predata.tax_price.value}}</label>
                <el-input v-if="predata.tax_price.need_frontend_input==1" placeholder="价格" v-model="predata.tax_price.value">
                  <template slot="append">{{predata.tax_price.currency_symbol}}</template>
                </el-input>
            </li>
            <li><span>商家运费</span><del
                v-if="predata.transport_price.need_frontend_calculate!=1 && predata.original_transport_price.value != predata.transport_price.value">{{predata.original_transport_price.currency_symbol}}{{predata.original_transport_price.value}}</del>
                <label v-if="predata.transport_price.need_frontend_input!=1">{{predata.transport_price.currency_symbol}}{{predata.transport_price.value}}</label>
                <el-input @change="recomputetotal('transport_price')" v-if="predata.transport_price.need_frontend_input==1" placeholder="价格" v-model="predata.transport_price.value">
                  <template slot="append">{{predata.transport_price.currency}}</template>
                </el-input>
            </li>
            <li><span>其他费用</span><del
                v-if="predata.other_price.need_frontend_calculate!=1 && predata.original_other_price.value != predata.other_price.value">{{predata.original_other_price.currency_symbol}}{{predata.original_other_price.value}}</del>
                <label v-if="predata.other_price.need_frontend_input!=1">{{predata.other_price.currency_symbol}}{{predata.other_price.value}}</label>
                <el-input @change="recomputetotal('other_price')" v-if="predata.other_price.need_frontend_input==1" placeholder="价格" v-model="predata.other_price.value">
                  <template slot="append">{{predata.other_price.currency}}</template>
                </el-input>
            </li>
            <li><span>商家小计</span><del
                v-if="predata.subtotal_price.need_frontend_calculate!=1 && predata.original_subtotal_price.value != predata.subtotal_price.value">{{predata.original_subtotal_price.currency_symbol}}{{predata.original_subtotal_price.value}}</del>
                <label v-if="predata.subtotal_price.need_frontend_input!=1">{{predata.subtotal_price.currency_symbol}}{{predata.subtotal_price.value}}</label>
                <el-input v-if="predata.subtotal_price.need_frontend_input==1" placeholder="价格" v-model="predata.subtotal_price.value">
                  <template slot="append">{{predata.subtotal_price.currency}}</template>
                </el-input>
            </li>
            <li><span>优惠码</span> {{predata.coupon_text}}</li>
            <hr class="line">
            <li><span>服务费</span><del
                v-if="predata.service_price.need_frontend_calculate!=1 && predata.original_service_price.value != predata.service_price.value">{{predata.original_service_price.currency_symbol}}{{predata.original_service_price.value}}</del>
                <label v-if="predata.service_price.need_frontend_input!=1">{{predata.service_price.currency_symbol}}{{predata.service_price.value}}</label>
                <el-input @change="recomputetotal('service_price')" v-if="predata.service_price.need_frontend_input==1" placeholder="价格" v-model="predata.service_price.value">
                  <template slot="append">{{predata.service_price.currency}}</template>
                </el-input>
            </li>
            <hr class="line">
            <li><span>国际运费</span><del
                v-if="predata.international_transport_price.value != predata.original_international_transport_price.value">{{predata.original_international_transport_price.currency_symbol}}{{predata.original_international_transport_price.value}}</del>
                <label v-if="predata.international_transport_price.need_frontend_input!=1">{{international_transport_price_display()}}</label>
                <el-input @change="recomputetotal('international_transport_price')" v-if="predata.international_transport_price.need_frontend_input==1" placeholder="价格" v-model="predata.international_transport_price.value">
                  <template slot="append">{{predata.international_transport_price.currency}}</template>
                </el-input>
            </li>
            <li style="padding:10px 0px;line-height: inherit;">
              <span @click="edit_after_sales_service_fee=true">
                售后服务费
                <i class="el-icon-edit-outline" style="cursor: pointer;"></i>
              </span>
              <label>{{predata.after_sales_service_fee.currency_symbol+predata.after_sales_service_fee.value}}</label>
              <YueDanIpt style="margin:20px 0 10px;" v-show="edit_after_sales_service_fee" :reg="/^\d+\.?\d{0,2}$/" model="value" :object="after_sales_service_fee" placeholder="售后服务费" append="CNY"></YueDanIpt>
              <div v-show="edit_after_sales_service_fee" style="display: flex;justify-content: space-between;">
                <el-button size="small" @click="edit_after_sales_service_fee=false" style="width:48%;">取 消</el-button>
                <el-button size="small" type="info" @click="confirm_edit_after_sales" style="width:48%;">确 定</el-button>
              </div>
            </li>
            <li><span>实时汇率</span>{{predata.rate}}</li>
            <li><span>总计</span><del
                v-if="predata.total_price.need_frontend_calculate!=1 && predata.original_total_price.value != predata.total_price.value">{{predata.original_total_price.currency_symbol}}{{predata.original_total_price.value}}</del>
                <label v-if="predata.total_price.need_frontend_input!=1">{{predata.total_price.currency_symbol}}{{predata.total_price.value}}</label>
                <el-input v-if="predata.total_price.need_frontend_input==1" placeholder="价格" v-model="predata.total_price.value">
                  <template slot="append">{{predata.total_price.currency}}</template>
                </el-input>
            </li>
            <li><span>{{predata.payment_status}}</span>
              {{predata.payment_price.currency_symbol}}{{predata.payment_price.value}}
            </li>
            <li v-if="predata.paying_amount.value!='0.00'"><span>支付中</span>
              {{predata.paying_amount.currency_symbol}}{{predata.paying_amount.value}}
            </li>
            <li v-if="predata.paying_amount.value!='0.00'"><span>退款中</span>
              {{predata.refunding_amount.currency_symbol}}{{predata.refunding_amount.value}}
            </li>
          </ul>
          <div class="fee_row">
            <el-button class="block" :type="'primary'" @click="submit" :loading="loading" :disabled="edit_after_sales_service_fee">确定提交</el-button>
          </div>
        </div>
        <div v-if="step == 2">
          <el-row class="select-address">
            <el-col :span="24" class="tip">
              选择取消理由
            </el-col>
          </el-row>
          <el-form>
            <el-row>
              <el-col :span="24" v-for="(res,index) in ressons" :key="index">
                <el-form-item style="margin-bottom: 0!important;">
                  <el-radio v-model="reason" :label="res">{{res}}</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item>
                  <el-button :loading="isStartCaculating" style="margin: 20px 0 20px;" class="block" :type="'primary'" @click="next"
                    >{{isStartCaculating?'计算费用中，请等待...':'确定'}}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import api from '../../../../services/api.js'
  import { API_HOST } from '../../../../services/constant.js'
  import YueDanIpt from '../../../../components/YueDanIpt'
  import ProductList from './ProductList'
  let _ = require('lodash')

  export default {
    name: 'CancelPackage',
    props: ['order', 'isSingle','mobiletype'],
    components: {
      ProductList: ProductList,YueDanIpt:YueDanIpt
    },
    data() {
      return {
        edit_after_sales_service_fee:false,
        after_sales_service_fee:{value:''},
        notNext:false,
        account_id:this.$localStorage.get('account_id'),
        role:this.$localStorage.get('role'),
        needCancelAll:false,
        goods_info: [],
        uploadType: '1',
        groupOrderLine: [],
        otherGoods:[],
        reason: '商家缺货',
        ressons: [
          '商家缺货',
          '优惠过期',
          '买单人不想买了',
          '其他原因'
        ],
        dialogFormVisible: false,
        loading: false,
        step: 1,
        isEmptyErrors: true,
        errors: {},
        ids: [],
        status: '', // 订单状态
        data: [],
        fee_info: [
          { name: '商品金额', editMode: false, fee: 0, fieldName: 'goods_price', canEdit: false },
          { name: '消费税', editMode: false, fee: 0, fieldName: 'tax_price', canEdit: false },
          { name: '商家运费', editMode: false, fee: 0, fieldName: 'transport_price', canEdit: true },
          { name: '其他费用', editMode: false, fee: 0, fieldName: 'other_price', canEdit: true },
          { name: '汇率', editMode: false, fee: 0, fieldName: 'rate', canEdit: false },
          { name: '商家小计', editMode: false, fee: 0, fieldName: 'subtotal_price', canEdit: false },
          { name: '服务费', editMode: false, fee: 0, fieldName: 'service_amount', canEdit: false },
          { name: '国际运费', editMode: false, fee: 0, fieldName: 'international_transport_price', canEdit: true },
          { name: '待退回', editMode: false, fee: 0, fieldName: 'total_price', canEdit: false },
        ],
        flexFeeRate: 0,
        fixedFee: 0,
        restGoods: [],
        cancelGoods:[],
        zhiyoumobanlist:[],
        //restfreightRes:'',
        //restexpressPrice:'',
        isStartCaculating:false,
        predata:null,
        original_predata:null
        //international_transport_price_no:'按重量实收'
      }
    },
    methods: {
      confirm_edit_after_sales(){
        this.getpredata(true)
      },
      canNext(){
        this.notNext = this.groupOrderLine.filter(i=>i.checked).length==0
      },
      international_transport_price_display(){
        let t=this.predata.international_transport_price.currency_symbol+this.predata.international_transport_price.value
        console.log('国际运费',t)
        switch(this.predata.international_transport_price.charge_type){
          case "1":
          case "2":
            return this.predata.international_transport_price.charge_type_message+(this.needCancelAll?t:'');
          default:
            return t
        }
      },
      recomputetotal(field){
        this.predata.total_price.value=(+this.predata.total_price.value)+(+this.predata[field].value);
        this.recomputedrefunding()
      },
      gotoFee() {
        this.getMerchant();
      },
      getMerchant() {
        api.getMerchantDetail(this, { id: this.order.business_id }).then((res) => {
          this.step = 3;
          this.fee_info[0].fee = this.order.price_info.goods_price;
          let tax_amount_percent = (this.order.business_id === '4474' ? 0.05 : 0);
          this.fee_info[1].fee = (+this.fee_info[0].fee) * tax_amount_percent;
          let theMerchant = res.body.result;
          let flexFeeRate = this.order.service_type == 1 ? theMerchant.single_service_rate : theMerchant.buyer_service_rate
          this.flexFeeRate = +flexFeeRate.substr(0, flexFeeRate.length - 1)
          this.fixedFee = this.order.service_type == 1 ? theMerchant.single_fixed_amount : theMerchant.buyer_fixed_amount
          this.fee_info[6].fee = ((+this.fee_info[0].fee) + (+this.fee_info[1].fee)) * this.flexFeeRate / 100 + (+this.fixedFee)
        })
      },
      toEditMode(fee) {
        if (fee.canEdit) {
          fee.editMode = true;
        }
      },
      closeEditMode(fee) {
        let t=((+this.fee_info[0].fee) + (+this.fee_info[1].fee) + (+this.fee_info[2].fee) + (+this.fee_info[3].fee))
        this.fee_info[5].fee = this.$decimalFormat(t,2)
        let t2=((+this.fee_info[5].fee) + (+this.fee_info[6].fee) + ((+this.fee_info[7].fee)))
        this.fee_info[8].fee = this.$decimalFormat(t2,2)
        fee.editMode = false;
      },
      showChooseImage() {
        this.$emit('showChooseImage', 'cancelType2product')
      },
      changeType(data) {
        this.uploadType = data
        this.isEmptyErrors = true
        this.errors = {}
      },
      show() {
        let maishouenable=this.role==1 || this.order.single_account_id==this.account_id || (this.order.merchant_administrator_account_id_list && this.order.merchant_administrator_account_id_list.indexOf(this.account_id)>-1)
        this.goods_info = [
          { image: '', remark: '', id: new Date().getTime() }
        ]
        this.dialogFormVisible = true
        this.status = this.order.status
        this.groupOrderLine = []
        this.otherGoods=[]

        let filterArray=[];
        if(maishouenable || this.order.business_shipping_account_id==this.account_id)
          filterArray.push('4');
        if(maishouenable || this.order.transport_shipping_account_id==this.account_id)
          filterArray.push('5')
        if(maishouenable || this.order.transport_shipping_account_id==this.account_id)
          filterArray.push('6')
        _.each(this.order.goods_list, item => {
          item.checked = false
          if (filterArray.indexOf(item.status) > -1) {
            this.groupOrderLine.push(item)
          }
          console.log('groupOrderLine',this.groupOrderLine)
          /*else if(['0', '1','3','7'].indexOf(item.status) == -1) {
            this.otherGoods.push(item)
          }*/
        })
      },
      close() {
        this.isEmptyErrors = true
        this.errors = {}
        this.step = 1
        this.ids = []
        this.reason = '商家缺货'
        _.each(this.groupOrderLine, line => {
          line.checked = false
        })
      },
      async submit() {
        let res
        res = await api.post(this, {
              path: 'order.php',
              api: 'return_order_good_list',
              data: {
                order_id: this.order.id,
                need_cancel_good_list:this.cancelGoods,
                reason: this.reason,
                update_time: this.order.update_time,
                international_transport_price:this.predata.international_transport_price.value,
                transport_price:this.predata.transport_price.value,
                after_sales_service_fee:this.predata.after_sales_service_fee.value
              },
              loading: 'loading'
          })
          res = res.body
          if (res.status == 'ok') {
            Object.assign(this.order, res.result)
            this.order.update_time = res.result.update_time
            this.order.cancel_time = res.result.cancel_time
            this.order.status = res.result.status
            if(this.order.type == 0){
              this.data = {
                status: this.status,
                operationType: '取消商品成功',
                name: '付款人',
                type: '商品',
                refund: this.predata.payment_price.value
              }
            }
            _.each(this.groupOrderLine, line => {
              if (line.checked) {
                line.status = '3'
              }
            })
            this.$emit('lineChange')
            this.dialogFormVisible = false
            this.step = 1
            if (this.order.status == '30') {
              if (this.order.shipping_info.length > 0) {
                if (this.order.fee_adjustment_list.length == 0) {
                  if (Number(this.order.transport_amount) > 0 || Number(this.order.other_amount) > 0) {
                    this.data.showRefundTip = true
                  } else {
                    this.data.showRefundTip = false
                  }
                } else {
                  if (Number(this.order.transport_amount) > 0 || Number(this.order.other_amount) > 0 || Number(this.order.fee_adjustment_list[0].package_forwarding_fee) > 0) {
                    this.data.showRefundTip = true
                  } else {
                    this.data.showRefundTip = false
                  }
                }
              }
            } else {
              this.data.showRefundTip = false
            }
            this.$emit('complete', this.data)
            this.$emit('refresh',res.result.price_info)
          }
      },
      async getrefund() {
        let ids=this.ids.map((i)=>{
          return i.good_id
        })
        let amount = await api.post(this, {
          path: 'order.php',
          api: 'amount_when_cancel_good',
          data: {
            order_id: this.order.id,
            good_ids: ids.join(',')
          },
          loading: 'loading'
        })
        amount = amount.body
        if (amount.status == 'ok') {
          this.data = {
            status: this.status,
            operationType: '取消商品成功',
            name: '付款人',
            type: '商品',
            refund: amount.result
          }
        }
      },
      gotStep2(){
        if (this.order.type == '2') {
          let totalPrice=0;
          _.each(this.goods_info, item => {
            /*if (!item.image && !item.remark) {
              this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  {message: '请上传要取消的商品截图/凭证或填写要取消的商品名称和信息'}
                ]
              }
              return false*/
            if (!item.remark) {
              this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  { message: '请填写要取消的商品名称和信息' }
                ]
              }
              return false
            } else if (!item.inputPrice || isNaN(Number(item.inputPrice))) {
              this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  { message: '请填写正确的价格' }
                ]
              }
              return false
            } else {
              totalPrice+=(+item.inputPrice)
              this.isEmptyErrors = true
              this.errors = {}
            }
          })
          if(totalPrice>(+this.order.price_info.goods_price.value)){
            this.isEmptyErrors = false
                  this.errors = {
                    business_name: [
                      { message: '价格超出了任务总价格' }
                    ]
                  }
            return false
          }
          if(totalPrice==(+this.order.price_info.goods_price.value)){
            this.needCancelAll=true;
          }
        }
        // 这个是报错信息的返回
        if (!this.isEmptyErrors) {
          return
        }
        this.step=2;
      },
      next() {
        //小程序来源的订单
        this.isStartCaculating=true;
        this.ids = []
        this.restGoods=[]
        this.restGoodsPrice=0;
        this.cancelGoods=[];
        if (this.order.type == 0) {
          _.each(this.groupOrderLine, line => {
            if (line.checked) {
              // if (~~line.selectNum !== ~~line.number) {
              this.ids.push({ good_id: line.id, number: line.selectNum })
              this.cancelGoods.push({ id: line.id, number: line.selectNum });
              // } else {
              //   this.ids.push(line.id)
              // }
            }
            else {
              this.restGoodsPrice += (+line.price) * (+line.selectNum)
              this.restGoods.push(line)
            }
          })
          _.each(this.otherGoods, line => {
              this.restGoodsPrice += (+line.price) * (+line.selectNum)
              this.restGoods.push(line)
          })
          if(this.restGoodsPrice==0)
            this.needCancelAll=true;
          else
            this.needCancelAll=false;
          if (this.ids.length == 0) {
            this.dialogFormVisible = false
          } else {
            this.getpredata()
            //this.step = 2;
          }
        }
        else if (this.order.type == 2) {
          this.goods_info.forEach((g)=>{
            let good={}
            good.price=g.inputPrice;
            good.discounted_price=g.inputPrice;
            this.cancelGoods.push(good);
          })
          this.getpredata()
          //this.step = 2
          //this.isStartCaculating=false  
        }
      },

      //以下是计算商家运费，国际运费，服务费
      serviceFeeCount() {
        let flexFeeRate = this.order.service_type == 1 ? this.order.business.single_service_rate : this.order.business.buyer_service_rate
        flexFeeRate = +flexFeeRate.substr(0, flexFeeRate.length - 1)
        this.restServiceFee = this.restGoodsPrice * flexFeeRate / 100
        //this.fixedFee = this.orderInfo.service_type==1?theMerchant.single_fixed_amount:theMerchant.buyer_fixed_amount			
      },
      getpredata(recacu) {
        let url=API_HOST+"/api/order.php?api=get_price_info&type=6";
          let data={};
          data.order_id=this.order.id;
          data.need_cancel_good_list=this.cancelGoods
          if(recacu){
            this.loading=true;
            data.after_sales_service_fee=+this.after_sales_service_fee.value;
          }
          this.$http.post(url,data).then(data =>{ 
            this.predata=data.body.result;
            this.original_predata=JSON.parse(JSON.stringify(data.body.result))
            if(recacu){
              this.loading=false;
              this.edit_after_sales_service_fee=false;
            }
            else{
              this.step=3;
              this.isStartCaculating=false;
              /*if(this.predata.transport_price.need_frontend_calculate==1 && this.restGoods.length){
                this.recaculate()
              }
              else{
                this.step=3;
                this.isStartCaculating=false;
              }*/
            }
          })
        /*if(this.needCancelAll){
          let url=API_HOST+"/api/order.php?api=get_price_info&type=2";
          this.$http.post(url,{order_id:this.order.id}).then(data =>{ 
            //this.step=1;
            this.predata=data.body.result;
            this.step=3;
            this.isStartCaculating=false  
          })
        }
        else{
          let url=API_HOST+"/api/order.php?api=get_price_info&type=3";
          let data={};
          data.order_id=this.order.id;
          data.need_cancel_good_list=this.cancelGoods
          this.$http.post(url,data).then(data =>{ 
            this.predata=data.body.result;
            this.original_predata=JSON.parse(JSON.stringify(data.body.result))
            if(this.predata.transport_price.need_frontend_calculate==1){
              this.recaculate()
            }
            else{
              this.step=3;
              this.isStartCaculating=false;
            }
          })
        }*/
      },
      async recaculate() {
        //this.serviceFeeCount();
        //第一步：获取商家信息，包括国家，直邮模板，国际运费模板
        let merchant = await api.getMerchantDetail(this, { id: this.order.business_id })
        //第二步：获取剩下货物的重量
        /*let weight = await api.get_good_weight_info_list(this,{
          id_info_list: this.sizeDataInit(this.restGoods)
        })*/
        let weight = await api.post(this, {
          path: 'good.php',
          api: 'get_good_weight_info_list',
          data: {
            id_info_list: this.sizeDataInit(this.restGoods)
          }
      })
        //第三步：获取商品和模板关系数组
        /*let goods_template=await api.get_transport_amount_template_relationship_list_by_id_list(this,{
						good_info_list: this.freightDataInit(this.restGoods)
				})*/
        let goods_template=await api.post(this,{
          path:'good.php',
          api:'get_transport_amount_template_relationship_list_by_id_list',
					data:{
            good_info_list: this.freightDataInit(this.restGoods)
          }
				})
        let theMerchant = merchant.body.result;
        this.zhiyoumobanlist = theMerchant.direct_delivery_transport_amount_template_full_list
        if (this.order.service_type == 1 || this.zhiyoumobanlist.length <= 1)
          this.predata.transport_price.value = this.handleExpressPrice(theMerchant.country, this.zhiyoumobanlist)
        this.freightCal(weight.body.result, goods_template.body.result)
        //剩下商品的商家运费，国际运费，服务费三个费用算完之后，提交到后端
        this.predata.total_price.value=(+this.original_predata.total_price.value)+(+this.predata.transport_price.value)+(this.predata.international_transport_price.value!=-1?(+this.predata.international_transport_price.value):0);
        //重新计算待退款
        this.recomputedrefunding()
        this.step=3;
        this.isStartCaculating=false
        console.log('test',this.restGoodsPrice,this.restServiceFee,this.order.price_info.other_price.value)
      },
      recomputedrefunding(){
        let t=((+this.predata.paid_amount.value)+(+this.predata.paying_amount.value)-(+this.predata.total_price.value)-(+this.predata.refunding_amount.value))
        this.predata.payment_price.value=this.$decimalFormat(t,2)
      },
      freightDataInit(goods_list){
        const pattern = new RegExp(/\((.+)\)/g)				
				let addressCountry = this.order.address.country.match(pattern)[0].replace('(', '').replace(')', '')
				return goods_list.map(x=>{return{good_id: x.good_id,merchant_id: this.order.business_id,receiving_area:addressCountry}})
			},
      handleExpressPrice(country, templates, zhuanyunStartArea) {
        let curTemplate = {}
        if (this.order.service_type == 2 && zhuanyunStartArea) {
          curTemplate = templates.find(t => t.receiving_area == zhuanyunStartArea);
        }
        else
          curTemplate = templates.find(t => t.receiving_area == country);
        if (!curTemplate) {
          return '0.00';
        }
        //先处理是否满足包邮条件，如果满足则不需要计算邮费
        if (this.isFreeShippingCondition(this.restGoods, curTemplate)) {
          return '0.00';
        }
        return this.freightCount(this.restGoods, curTemplate);
      },
      isJsonString(str) {
        try {
          if (typeof JSON.parse(str) == 'object')
            return true
        }
        catch (e) {
          return false;
        }
      },
      isFreeShippingCondition(products, template) {
        let isFreeShipping = false;
        let totalPrice = 0;
        let totalNum = 0;
        products.forEach((p) => {
          totalPrice += (+p.price) * (+p.number);
          totalNum += +p.number;
        })
        let terms_for_mailing = {};
        if (!this.isJsonString(template.terms_for_mailing)) {
          return true;
        }
        let t = JSON.parse(template.terms_for_mailing);
        if (Array.isArray(t)) {
          if (t.length)
            terms_for_mailing = t[0]
          else
            return true
        }
        else
          terms_for_mailing = t;
        switch (+terms_for_mailing.conditionType) {
          case 1:
            if (totalPrice >= +terms_for_mailing.price)
              isFreeShipping = true;
            break;
          case 2:
            if (totalNum >= +terms_for_mailing.count)
              isFreeShipping = true;
            break;
          case 3:
            if (totalPrice >= +terms_for_mailing.price || totalNum >= +terms_for_mailing.count)
              isFreeShipping = true;
            break;
          case 4:
            if (totalPrice >= +terms_for_mailing.price && totalNum >= +terms_for_mailing.count)
              isFreeShipping = true;
            break;
          default:
            isFreeShipping = false;
            break;
        }
        return isFreeShipping;
      },
      sizeDataInit(goods_list) {
        return goods_list.map(x => {
          if (x.good_id != 0) {
            let spec = JSON.parse(x.spec)
            return {
              id: x.good_id,
              attribute: spec.size || spec.volume
            }
          } else return 0
        })
      },
      productDivide(products, type, amount_limit, number_limit) {
        // ----------参数准备 start-------------
        var amount_condi = (arr, x, limit) => {
          // 单件金额不受限
          if (arr.length == 0) return true
          else return limit == 0 || this.priceSum(arr, x) <= limit
        }
        var number_condi = (arr, x, limit) => {
          return limit == 0 || (arr.length + 1) <= limit
        }
        var next = (site, len) => {
          if (site == len - 1) return 0
          return site++
        }
        // ----------参数准备 end---------------
        let res = []
        // let priceAmount = this.priceSum(products)
        let divideNumber = 1
        if (amount_limit > 0) {
          let cheepProducts = products.filter(x => x.rmbPrice < amount_limit)
          let expensiveProducts = products.filter(x => x.rmbPrice >= amount_limit)
          let priceAmount = this.priceSum(cheepProducts)
          divideNumber = Math.ceil(priceAmount / amount_limit) + expensiveProducts.length
        }
        if (number_limit > 0) {
          divideNumber = Math.max(divideNumber, Math.ceil(products.length / number_limit))
        }

        for (let i = 0; i < divideNumber; i++) {
          res.push([])
        }
        let site = 0
        for (let i = 0; i < products.length; i++) {
          let siteFindStart = site
          while (!(amount_condi(res[site], products[i], amount_limit) && number_condi(res[site], products[i], number_limit))) {
            if (site == res.length - 1) site = 0
            else site++
            if (siteFindStart == site) {
              res.push([])
              site = res.length - 1
            }
          }
          res[site].push(products[i])
          if (site == res.length - 1) site = 0
          else site++
        }
        return res
      },
      weightSum(products) {
        return this.$decimalFormat((+products.reduce((x, y) => +y.weight + x, 0)),3)
      },
      numSum(products) {
        return +products.reduce((x, y) => +y.number + x, 0)
      },
      priceSum(products, x) {
        if (x) return +x.rmbPrice + products.reduce((x, y) => +y.rmbPrice + x, 0)
        else return +products.reduce((x, y) => +y.rmbPrice + x, 0)
      },
      freightCal(weightData, freightTlData){
				//let len = freightTlData.length/2
				let len = freightTlData.length
        let hasWeightData=typeof(weightData)=='object'?true:false
				let freightSet= new Set()
				for (let i=0; i<len; i++){
					if (this.restGoods[i].good_id==0) continue
					this.restGoods[i].weight = hasWeightData?weightData[i].weight.value:0
					this.restGoods[i].rmbPrice = this.$decimalFormat((this.restGoods[i].discounted_price * this.order.price_info.rate),2)
					// 商家商品有运费模板：无，选择独立商品中国家符合的
					/*if (freightTlData[i].list.length>0){
						this.productList[i].freight = freightTlData[i].list[0]
					} else {
						this.productList[i].freight = freightTlData[i+len].list.find(x=>x.area==this.theMerchant.country)
					}*/
					if(freightTlData[i].list.length){
						this.restGoods[i].freight = freightTlData[i].list[0]
						freightSet.add(this.restGoods[i].freight.id)
					}
				}
				freightSet = Array.from(freightSet)
				let expressPriceList=[]
				if(freightSet.length){
					let freightList = []
					freightSet.forEach(freightId=>{
						let productTheTemplate = this.restGoods.filter(x=>x.freight&&x.freight.id==freightId)
						let theTemplate = productTheTemplate[0].freight
						freightList.push(this.freightCount(productTheTemplate,theTemplate))
						//如果是下单＋转运模式而且直邮模板多于1个，则需要根据转运模板的起始地区选择模板
						if(this.order.service_type==2 && this.zhiyoumobanlist.length>1)
							expressPriceList.push(this.handleExpressPrice(null,this.zhiyoumobanlist,theTemplate.area))
					})
					
					this.predata.international_transport_price.value = this.$decimalFormat(freightList.reduce((x,y)=>x+y,0),2)
				}
				else{
					this.predata.international_transport_price.value=0;
				}
				if(this.order.service_type==2 && this.zhiyoumobanlist.length>1)
					this.predata.transport_price.value = this.$decimalFormat(expressPriceList.reduce((x,y)=>x+y,0),2)
			},
      freightCount(product, theTemplate) {
        // ----------参数准备 start-------------
        var freightCalByWeight = (packages, fee1, fee2, fee3, fee4) => {
          let weight = this.weightSum(packages)
          let res
          if (weight < fee1) res = fee2
          else res = this.$decimalFormat((fee2 + (weight - fee1) / fee3 * fee4),2)
          return res
        }
        var freightCalByNum = (packages, fee1, fee2, fee3, fee4) => {
          let num = packages.length
          if (num < fee1) return fee2
          else return this.$decimalFormat((fee2 + (num - fee1) / fee3 * fee4),2)
        }
        // ----------参数准备 end---------------

        // 商品展开，并按价格从高到低排序
        let products = []
        product.forEach(x => {
          for (let i = 0; i < +x.number; i++) {
            products.push(x)
          }
        })
        products = products.sort((a, b) => +b.rmbPrice - (+a.rmbPrice))
        let shipping_type = {};
        /*if(!this.isJsonString(theTemplate.shipping_type)){
          return true;
        }*/
        let t = JSON.parse(theTemplate.shipping_template_param_set || theTemplate.shipping_type);
        if (Array.isArray(t)) {
          shipping_type = t[0]
        }
        else
          shipping_type = t;
        //theTemplate.shipping_type = JSON.parse(theTemplate.shipping_type)
        let { fee1, fee2, fee3, fee4 } = shipping_type
        fee1 = +fee1
        fee2 = +fee2
        fee3 = +fee3
        fee4 = +fee4
        let amount_limit = +theTemplate.amount_limit, number_limit = +theTemplate.number_limit
        // 若无门槛包邮，不计算运费
        if (theTemplate.free_shipping == '2') {
          return '0.00'
        }
        // 进行分包
        // if (amount_limit + number_limit==0) productPackages.push(products)
        // else productPackages = productDivide(products,theTemplate.valuation_type,amount_limit,number_limit,fee1,fee2,fee3,fee4)
        let productPackages = this.productDivide(products, theTemplate.valuation_type, amount_limit, number_limit, fee1, fee2, fee3, fee4)
        // 各包运费计算
        let freightForPackage = []
        for (let i = 0; i < productPackages.length; i++) {
          let packages = productPackages[i]
          if (theTemplate.valuation_type == '1') {
            // 按重量
            freightForPackage.push(freightCalByWeight(packages, fee1, fee2, fee3, fee4))
          }
          if (theTemplate.valuation_type == '2') {
            // 按件数
            freightForPackage.push(freightCalByNum(packages, fee1, fee2, fee3, fee4))
          }
        }
        return +freightForPackage.reduce((x, y) => +y + x, 0)

      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .popover-price {
    padding: 13px 13px;
    li {
      clear: both;
      text-align: right;
      color: #333333;
      line-height: 24px;

      span {
        float: left;
        color: #999999;
      }

      del {
        color: #B0B4BF;
      }
    }

    .line {
      float: left;
      width: 100%;
      height: 1px;
      border: 1px dashed #ccc;
    }
  }
  .cancel-body {
    display: flex;
  }

  .dialog-form {
    padding-bottom: 40px;
  }

  .tip {
    font-size: 16px;
    color: rgba(136, 136, 136, 1);
    line-height: 24px;
    margin-bottom: 5px;
  }

  .add-tip {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 24px;
    margin-left: 5px;
  }

  .back {
    float: left;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
  }

  .select-address {
    padding-bottom: 7px;
    border-bottom: 1px solid #CDCDCD;
    margin-bottom: 10px;
  }

  .mobile_upload_order {
    padding: 10px;
  }

  .error-messages {
    display: block;
    background-color: #fff1f1;
    padding: 10px;
    text-align: center;
    color: #ff4650;
    line-height: 17px;
    margin-bottom: 10px;
    border-radius: 5px;

    li {
      font-size: 12px;
    }
  }

  .fee_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 0;
  }

  .fee_row label.canEdit {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/pages/orders/list/single/PackageCancelDialog.vue